/**
 * Show/hide toggle for password form fields (x-jbuilder.form.password).
 * The space the button needs is handled in SCSS, so nothing here has to measure
 * the layout.
 */
const TOOLTIP_TEMPLATE = '<div class="tooltip jb-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>';

function initTooltip($toggle) {
  $toggle.tooltip({
    template: TOOLTIP_TEMPLATE,
    trigger: 'hover focus',
  });
}

/**
 * Bootstrap 4 caches the title on init, so the tooltip has to be rebuilt to
 * show the new label. Re-show it when it was already visible (the user just
 * clicked the button, so the pointer is still on it).
 */
function updateToggleLabel($toggle, label) {
  const wasVisible = !!$toggle.attr('aria-describedby');

  $toggle.attr('title', label).attr('aria-label', label);

  if ($toggle.data('bs.tooltip')) {
    $toggle.tooltip('dispose');
  }

  initTooltip($toggle);

  if (wasVisible) {
    $toggle.tooltip('show');
  }
}

function initPasswordToggleTooltips() {
  $('[data-password-toggle]').each(function() {
    const $toggle = $(this);

    if ($toggle.data('bs.tooltip')) return;

    initTooltip($toggle);
  });
}

function togglePasswordVisibility(toggle) {
  const wrapper = toggle.closest('[data-password-wrapper]');

  if (!wrapper) return;

  const input = wrapper.querySelector('[data-password-input]');

  if (!input) return;

  const shouldReveal = input.getAttribute('type') === 'password';
  const $toggle = $(toggle);

  input.setAttribute('type', shouldReveal ? 'text' : 'password');

  $(toggle.querySelector('[data-password-icon-show]')).toggleClass('d-none', shouldReveal).toggleClass('d-flex', !shouldReveal);
  $(toggle.querySelector('[data-password-icon-hide]')).toggleClass('d-none', !shouldReveal).toggleClass('d-flex', shouldReveal);

  updateToggleLabel($toggle, toggle.getAttribute(shouldReveal ? 'data-hide-label' : 'data-show-label'));
}

$(function() {
  // Delegated, so toggles added by a re-render (theme settings preview, reg
  // wall, wizard steps) keep working without being bound again.
  $(document).on('click', '[data-password-toggle]', function(event) {
    event.preventDefault();
    togglePasswordVisibility(this);
  });

  initPasswordToggleTooltips();

  // Tooltips still have to be created for toggles that appear after load.
  document.addEventListener('jb.section.rendered', initPasswordToggleTooltips);
  document.addEventListener('section.initiated', initPasswordToggleTooltips);
  document.addEventListener('reg_wall_opened', initPasswordToggleTooltips);
});
